<template>
  <div class="customize_container">
    <div class="customize_title"><img src="@/images/custom-title@2x.png"></div>
    <p class="star_des">只要以下簡單的四個步驟，就能訂製屬於您的客製化金牌，金牌王國開發簡易的線上客製系統，現在就動動手指開始訂製屬於您的客製化商品吧!可點選下方“直接開始”按鈕，立即客製化您的商品。</p>
    <div class="star_step">
      <img src="@/images/step-1@2x.png">
      <img src="@/images/step-2@2x.png">
      <img src="@/images/step-3@2x.png">
      <img src="@/images/step-4@2x.png">
    </div>
    <router-link to="/gold/customize/customize_step1">
       <button class="star_btn">直接開始</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "customizeStar"
};
</script>

<style scoped lang="scss">
button {
  @extend %button;
}
.customize_container {
  margin-top: 30px;
  margin-bottom: 60px;
}
.customize_title {
  img {
    width: 215px;
    @include betweenPhoneTable {
      width: 172px;
    }
  }
}
p {
  color: $secondaryDeepColor1;
  font-size: 17px;
  letter-spacing: 1px;
  width: 55%;
  margin: auto;
  @include table {
    width: 75%;
  }
}
.star_step {
  margin: 30px 8.6%;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(4, 1fr);
  @include tablePro {
    grid-template-columns: repeat(2, 1fr);
  }
  @include betweenPhoneTable {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  @include phone {
    margin: 30px 2%;
  }
  img {
    max-width: 100%;
    @include betweenPhoneTable {
      max-width: 286px;
    }
  }
}
</style>
